import { PageLink } from "@common-metronic/layout/core"
import {
     ROUTING_ABSOLUTE_PATH_GESTION_PRODUCTION_DECLARATIONS_VOYANTS,
     ROUTING_ABSOLUTE_PATH_GESTION_STRUCTURE_DECLARATIONS_VOYANTS,
     ROUTING_ABSOLUTE_PATH_GESTION_STRUCTURE_STAFF,
} from "./routing-endpoints"

export const ROUTING_BREADCRUMBS_GESTION: Array<PageLink> = [
     {
          title: "Gestion",
     },
]

export const ROUTING_BREADCRUMBS_GESTION_ASSURANCES: Array<PageLink> = [
     ...ROUTING_BREADCRUMBS_GESTION,
     {
          title: "Assurances",
     },
]

export const ROUTING_BREADCRUMBS_GESTION_ASSURANCES_LISTING: Array<PageLink> = [
     ...ROUTING_BREADCRUMBS_GESTION_ASSURANCES,
     {
          title: "Listing",
     },
]

export const ROUTING_BREADCRUMBS_GESTION_STRUCTURE: Array<PageLink> = [
     ...ROUTING_BREADCRUMBS_GESTION,
     {
          title: "Structure",
     },
]

export const ROUTING_BREADCRUMBS_GESTION_BASE_DOCUMENTAIRE: Array<PageLink> = [
     ...ROUTING_BREADCRUMBS_GESTION,
     {
          title: "Base documentaire",
     },
]

export const ROUTING_BREADCRUMBS_GESTION_STRUCTURE_STAFF: Array<PageLink> = [
     ...ROUTING_BREADCRUMBS_GESTION_STRUCTURE,
     {
          title: "Staff",
          path: ROUTING_ABSOLUTE_PATH_GESTION_STRUCTURE_STAFF,
     },
]

export const ROUTING_BREADCRUMBS_GESTION_STRUCTURE_STAFF_DEMANDES_EMBAUCHE: Array<PageLink> = [
     ...ROUTING_BREADCRUMBS_GESTION_STRUCTURE,
     {
          title: "Demandes d'embauche",
          path: `${ROUTING_ABSOLUTE_PATH_GESTION_STRUCTURE_STAFF}/demandes-embauche`,
     },
]

export const ROUTING_BREADCRUMBS_GESTION_STRUCTURE_DECLARATIONS_VOYANTS: Array<PageLink> = [
     ...ROUTING_BREADCRUMBS_GESTION_STRUCTURE,
     {
          title: "Déclarations ( voyants )",
          path: ROUTING_ABSOLUTE_PATH_GESTION_STRUCTURE_DECLARATIONS_VOYANTS,
     },
]

export const ROUTING_BREADCRUMBS_GESTION_PRODUCTION: Array<PageLink> = [
     ...ROUTING_BREADCRUMBS_GESTION,
     {
          title: "Production",
     },
]

export const ROUTING_BREADCRUMBS_GESTION_PRODUCTION_DECLARATIONS_VOYANTS: Array<PageLink> = [
     ...ROUTING_BREADCRUMBS_GESTION_PRODUCTION,
     {
          title: "Déclarations ( voyants )",
          path: ROUTING_ABSOLUTE_PATH_GESTION_PRODUCTION_DECLARATIONS_VOYANTS,
     },
]
